export const styles = theme => ({
    boxAction: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: theme.spacing(3)
    },
    title: {
        marginRight: theme.spacing(2)
    },
    boxImage:{
        marginTop: 0,
        margin: -theme.spacing(3)

    }
})